<div class="chat-wrapper" [ngClass]="{ 'chat-wrapper_mobile': isFriendshipOpen || previewMode }">
  <!-- NOTE: THIS IS THE CHATS CONTAINER -->
  <div
    *ngIf="showChats"
    class="messages-sidebar"
    [@slideInOut]="showChats ? 'open' : 'closed'"
    [ngClass]="{ 'messages-full-screen': showChatsFullScreen }"
  >
    <div class="messages-sidebar_header flex justify-content-between items-center">
      <p>Messages</p>
    </div>
    <div *ngIf="isUserLoaded" class="messages-sidebar_body">
      <stxt-conversation-list
        (click)="closeFullscreenMessages()"
        (keydown.enter)="closeFullscreenMessages()"
      ></stxt-conversation-list>
    </div>
  </div>

  <div class="chat">
    <div
      *ngIf="isCreatorDataExists"
      class="chat_header items-center flex"
      [ngClass]="{ 'friendship-open': isFriendshipOpen }"
    >
      <div class="chat_info flex items-center">
        <stxt-svg-icon
          [iconConfig]="backIcon"
          class="back-svg"
          (click)="navigateBack()"
          (keydown.enter)="navigateBack()"
        ></stxt-svg-icon>
        <div class="chat_contributors">
          <!-- * TODO -- Hidden for V1 since we won't allow users to upload pictires at this stage * -->
          <!-- <svg fill="none" height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg">
          <circle cx="20" cy="20" fill="#7B0072" r="20"/>
        </svg> -->
          <button class="btn-nostyle">
            <img [src]="creator.thumbnail_image" alt="creator" class="chat_creator__image" />
          </button>
        </div>
        <div class="chat_info">
          <button class="btn-nostyle flex flex-column items-start">
            <div class="chat_info__name">
              <img src="assets/icons/verified.svg" alt="verified" class="name-badge" />
              <p class="">{{ creator.creator_name }}</p>
            </div>
            <stxt-content-rating
              [ratingType]="
                creatorData.not_safe_for_work ? EContentRatingType.NSFW : EContentRatingType.SFW
              "
              [subscribed]="isSubscribed"
            ></stxt-content-rating>
          </button>
        </div>
      </div>
      <div class="chat_header__helpers">
        <stxt-button
          *ngIf="!isSubscribed"
          [buttonConfig]="subscriptionButtonConfig"
          (click)="openSubscriptionModal()"
          (keydown.enter)="openSubscriptionModal()"
          class="button-svg"
        >
          <stxt-svg-icon [iconConfig]="subscriptionIcon" class="subscription-svg"></stxt-svg-icon>
          <p>Subscribe</p>
        </stxt-button>
        <stxt-svg-icon
          [iconConfig]="questionIcon"
          class="chat-svg"
          ngbTooltip="Get help"
          placement="bottom"
          tooltipClass="custom-tooltip"
          (click)="window.open(getHelpLink, '_blank')"
          (keydown.enter)="window.open(getHelpLink, '_blank')"
        ></stxt-svg-icon>
        <stxt-svg-icon
          *ngIf="!isFriendshipOpen && isFriendshipEnabled"
          [iconConfig]="friendshipIcon"
          (click)="toggleFriendshipDrawer()"
          (keydown.enter)="toggleFriendshipDrawer()"
          class="chat-svg"
        ></stxt-svg-icon>
      </div>
    </div>

    <div
      *ngIf="isUserLoaded && isCreatorDataExists"
      #messageContainer
      class="chat_body flex flex-column"
      [ngClass]="{
        'preview-mode_body': previewMode,
        'full-body-width': !isFriendshipEnabled,
        'friendship-open': isFriendshipOpen
      }"
      [style.height.px]="chatBodyHeight"
      (scroll)="onScroll($event, activeChatId)"
    >
      <div
        class="chat_main flex flex-column"
        [@staggeredSlideFadeIn]="historyMessages.length + messages.length"
      >
        <ng-container>
          <div
            *ngFor="let messagePack of historyMessages; trackBy: trackByGroupDate"
            class="flex flex-column"
          >
            <p *ngIf="messagePack.date" class="grouped_message__date">{{ messagePack.date }}</p>
            <stxt-message
              *ngFor="let message of messagePack.messages; let i = index; trackBy: trackByFn"
              [chatState]="chatState"
              [creatorId]="creatorId"
              [creatorName]="creator.creator_name"
              [isFeedbackControlsEnabled]="isFeedbackControlsEnabled"
              [userId]="userId"
              [messageItem]="message"
              [selectedMessageAudio]="selectedMessageAudio"
              [voiceSupported]="false"
              (clicked)="setActive(i, message)"
              (isPreviewMode)="previewMode = $event"
              (triggerPayment)="unlockImage(message)"
              (updatePlayMessageState)="trackSelectedVoice($event)"
              [ngClass]="{
                'active-sender': activeIndex === message.timestamp && message.from_stxt,
                'active-receiver': activeIndex === message.timestamp && !message.from_stxt
              }"
              class="chat_message"
            ></stxt-message>
          </div>
        </ng-container>
        <p *ngIf="messages.length > 0" class="grouped_message__date">Today</p>
        <stxt-message
          *ngFor="let message of messages; let i = index; trackBy: trackByFn"
          [messageItem]="message"
          [chatState]="chatState"
          [creatorId]="creatorId"
          [userId]="userId"
          [isFeedbackControlsEnabled]="isFeedbackControlsEnabled"
          [creatorName]="creator.creator_name"
          [selectedMessageAudio]="selectedMessageAudio"
          [voiceSupported]="false"
          (clicked)="setActive(i, message)"
          (isPreviewMode)="previewMode = $event"
          (triggerPayment)="unlockImage(message)"
          (updatePlayMessageState)="trackSelectedVoice($event)"
          [ngClass]="{
            'active-sender': activeIndex === message.timestamp && message.from_stxt,
            'active-receiver': activeIndex === message.timestamp && !message.from_stxt
          }"
          class="chat_message"
        ></stxt-message>
      </div>
      <div *ngIf="isTyping" class="typing-message">
        <div class="loader"></div>
      </div>
      <div class="chat_body__paywall">
        <stxt-subscription-paywall
          *ngIf="isSubscription && creatorData.sub_plan && !isSubscribed"
          [creatorImg]="creator?.thumbnail_image"
          [subscriptionPrice]="creatorData?.sub_plan?.price"
          (subscribeEvent)="openPayment(EPaymentType.Subscription)"
        ></stxt-subscription-paywall>
      </div>
    </div>

    <div
      *ngIf="isUserLoaded && isCreatorDataExists"
      [ngClass]="{
        'preview-mode_footer': previewMode || !isUserLoaded,
        'full-footer-width': !isFriendshipEnabled,
        'friendship-open': isFriendshipOpen,
        'request-prompt': suggestedPrompts?.length && isShowSuggestions
      }"
      class="chat_footer"
      stxtClickOutside
      (clickOutside)="closeSuggestions($event)"
    >
      <div *ngIf="isCannedResponses" class="chat_canned-messages">
        <p class="chat_canned-messages__head">Pick an option:</p>
        <div class="chat_canned-messages__main">
          <stxt-canned-message
            *ngFor="let cannedMessage of cannedMessages"
            [message]="cannedMessage"
            (click)="sendMessage(cannedMessage)"
            (keydown.enter)="sendMessage(cannedMessage)"
          ></stxt-canned-message>
        </div>
      </div>

      <div [@fade] *ngIf="suggestedPrompts?.length && isShowSuggestions" class="prompt_list">
        <div *ngFor="let suggestedItem of filteredPrompts?.slice(0, 2)">
          <stxt-suggested-prompt
            [suggestedPrompt]="suggestedItem.short_prompt"
            [userInput]="userInput"
            [usageCase]="EPromptUsage.Chat"
            (click)="sendPromptMessage(suggestedItem)"
            (keydown.enter)="sendPromptMessage(suggestedItem)"
          ></stxt-suggested-prompt>
          <div class="prompt_divider"></div>
        </div>
      </div>
      <div
        *ngIf="!isCannedResponses"
        class="chat_textarea__wrapper"
        [ngClass]="{
          'generate-image': isShowSuggestions,
          'textarea-error': isInputLengthExceeded
        }"
      >
        <ng-container *ngIf="isInputLengthExceeded">
          <stxt-toast
            [toast]="inputLengthExceededToast"
            [showCloseButton]="false"
            class="chat_input_error_toast"
          ></stxt-toast>
        </ng-container>
        <div>
          <p *ngIf="isShowSuggestions" class="chat_generate__heading">Show me</p>
          <div [hidden]="isCannedResponses" class="input-custom flex w-full items-center relative">
            <span
              #inputMessage
              [style.height.px]="inputMessageHeight"
              (keydown)="onMessageInputChange($event)"
              (paste)="onPaste($event)"
              (input)="onInputChange(inputMessage.innerText)"
              class="input-message"
              contenteditable="true"
            ></span>
            <span *ngIf="!isMessageInputFilled(inputMessage?.innerText)" class="placeholder-text">
              {{ !isShowSuggestions ? "What's on your mind?" : "type what you'd like to see" }}
            </span>
            <div
              [ngClass]="{
                'message-input_button__enabled':
                  isMessageInputFilled(inputMessage?.innerText) || (isShowSuggestions && userInput),
                'message-input_button__disabled':
                  (!isMessageInputFilled(inputMessage?.innerText) &&
                    !(isShowSuggestions && userInput)) ||
                  isInputLengthExceeded
              }"
              class="message-input_button absolute"
            >
              <stxt-svg-icon
                [iconConfig]="sendIcon"
                (pointerdown)="!isInputLengthExceeded && sendMessage(inputMessage.innerHTML)"
                class="send-icon"
              ></stxt-svg-icon>
            </div>
          </div>
        </div>
        <ng-container *ngIf="!isCannedResponses && isRequestPhotosEnabled">
          <stxt-conversation-feature
            class="chat_textarea__features"
            [creatorData]="creatorData"
            [isGeneratePhoto]="isShowSuggestions"
            [isVoiceCallEnabled]="isVoiceCallEnabled && voiceSupported"
            (generateImage)="toggleGenerateImageMode()"
            (startVoiceCall)="isVoiceCall = true"
            (featureEvent)="handleFeatureEvent($event)"
          ></stxt-conversation-feature>
        </ng-container>
      </div>
      <p class="chat_footer__text">Remember: JustSext is all fantasy.</p>
    </div>
    <stxt-friendship-panel
      *ngIf="isFriendshipEnabled"
      #friendshipPanel
      [ngStyle]="{ display: isFriendshipOpen ? 'block' : 'none' }"
      [@slideInOut]="isFriendshipOpen ? 'open' : 'closed'"
      [creatorData]="creatorData"
      [friendsSince]="friendsSince"
      [isFriendshipOpen]="isFriendshipOpen"
      (closeFriendshipPage)="toggleFriendshipDrawer($event)"
      (requestPhotos)="openGenerateImageMode()"
    ></stxt-friendship-panel>
  </div>
</div>

<ng-container *ngIf="isPayment && isCreatorDataExists">
  <stxt-payment
    [creatorId]="creatorId"
    [creator]="creator.creator_name"
    [paymentType]="paymentType"
    [subscriptionData]="creatorData.sub_plan"
    [purchaseData]="purchaseData"
    [wsConnectionId]="wsConnectionId"
    (closePaymentEvent)="closePayment($event)"
  ></stxt-payment>
</ng-container>

<ng-container *ngIf="!isUserLoaded && userId">
  <div class="loading_wrapper">
    <stxt-loading [loadingText]="ELoadingTexts.GetReadyToImagine"></stxt-loading>
  </div>
</ng-container>

<ng-container *ngIf="!conversations.length && isUserLoaded && !creatorId">
  <div class="empty_wrapper">
    <stxt-empty-state
      [emptyStateData]="emptyStateData"
      (emptyStateButtonClicked)="router.navigateByUrl('')"
    ></stxt-empty-state>
  </div>
</ng-container>

<ng-container *ngIf="isToastMessage">
  <stxt-toast [toast]="toast" (closeToast)="isToastMessage = false" class="chat_toast"></stxt-toast>
</ng-container>

<ng-container *ngIf="isVoiceCall">
  <stxt-voice-call
    [creatorData]="creatorData"
    [userId]="userId"
    [tokensBalance]="tokens"
    (closeVoiceCall)="isVoiceCall = false"
  ></stxt-voice-call>
</ng-container>
